import { Injectable, inject } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { SubsidiaryDetailStoreSelectors } from 'apps/console/src/app/root-store/subsidiary-detail-store';

@Injectable({
	providedIn: 'root'
})
export class ActiveRouteService {
	protected router = inject(Router);
	protected route = inject(ActivatedRoute);
	protected store = inject(Store);


	public tenantTitle$ = new Subject<string>()

	constructor() {
		combineLatest([
			this.router.events.pipe(
				filter(event => event instanceof NavigationEnd),
				map(_ => this.findLastChild(this.route.snapshot)),
				map(route => this.hasAncestorWithTenant(route)),
			),
			this.store.select(SubsidiaryDetailStoreSelectors.selectSubsidiary)
		]).pipe(
			tap(([ showTenant, subsidiary ]) => this.tenantTitle$.next(
				showTenant && subsidiary ? subsidiary.name : null
			))
		).subscribe()
	}

	findLastChild(route: ActivatedRouteSnapshot) {
		while (route.firstChild) route = route.firstChild;
		return route;
	}

	hasAncestorWithTenant(route: ActivatedRouteSnapshot) {
		while (route.parent && !route.data.showTenant) route = route.parent;
		return !!route.data.showTenant;
	}
}
